const factorialCode: string = `program factorial💩

🚀 🔢 factorial(🔢 x) {
  🤔 (x◀️⬅️1) {
    🤲 1💩
  }
  ❌{
    🤲 x * factorial(x-1)💩
  }💩
}

main() {
  🖨(🔤Factorial of 5🔤, factorial(5))💩
}`;
export default factorialCode;
